import state from '@ugc-store';
import { getCookie, getUrlParams, detectIsMobile } from '@ugc-utils/utils';
import { getPreference } from '@ugc-utils/preference';

export interface ILanguage {
  country: string;
  language: string;
  currency: string;
}

interface ISessionId {
  aid: string;
}
export default function initGlobalState() {
  state.isDesktop = !detectIsMobile();

  state.preference = getPreference();

  const { aid = '' } = getUrlParams(decodeURIComponent(getCookie('ihr-session-id1'))) as ISessionId;
  state.isLogin = !!aid;
}
